var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"InputWrapper",class:{ '!bg-gray-100 dark:!bg-gray-600': _vm.disabled }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }